import React from 'react';
import { DatePicker } from 'antd';
import { WeekPickerProps } from 'antd/lib/date-picker';

const ProWeekPicke: React.FC<WeekPickerProps> = React.forwardRef<
  any,
  WeekPickerProps
>((props, ref) => {
  return (
    <DatePicker.WeekPicker ref={ref} {...props} />
  );
});

export default ProWeekPicke;
